import type { ProductVariantDetail } from "./productAnalysisModel";

export function productColorDisplayLabel(row: { label: string; color_name?: string }): string {
  const name = row.color_name?.trim();
  return name ? `${row.label} | ${name}` : row.label;
}

// The existing paginated API uses "SKU | canonical colour code" as its key.
// Split from the right: SKU identifiers themselves may contain spaces or pipes.
export function productColorIdentity(label: string) {
  const separator = label.lastIndexOf(" | ");
  if (separator <= 0 || separator + 3 >= label.length) throw new Error("Invalid SKU/colour identity");
  return { sku: label.slice(0, separator), color: label.slice(separator + 3) };
}

export function productDetailForColor(detail: ProductVariantDetail, label: string): ProductVariantDetail {
  const identity = productColorIdentity(label);
  if (detail.sku !== identity.sku) throw new Error("SKU detail mismatch");
  // Exact canonical code matching; never fall back to all colours or fabricate sizes.
  const variants = detail.variants.filter(variant => variant.color_code === identity.color);
  if (!variants.length) throw new Error("Selected colour detail is unavailable");
  return { ...detail, variants };
}
